import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { X } from 'lucide-react';

const AnalyticsConsentBanner = ({ acceptFunction, rejectFunction }
  : {
    acceptFunction: () => void; rejectFunction: () => void;

  }) => {
  const [showBanner, setShowBanner] = useState(false);

  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL;
  const privacyPolicyUrl = `${siteUrl}/policy.html`;

  useEffect(() => {
    const hasConsented = localStorage.getItem('analytics-enabled');
    if (hasConsented === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('analytics-enabled', JSON.stringify(true));
    setShowBanner(false);
    acceptFunction();
  };

  const handleReject = () => {
    localStorage.setItem('analytics-enabled', JSON.stringify(false));
    setShowBanner(false);
  };

  const handleClose = () => {
    // If they close without choosing, default to false
    localStorage.setItem('analytics-enabled', JSON.stringify(false));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Card className="max-w-4xl mx-auto shadow-lg border-green-200">
        <div className="p-4 relative">
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            aria-label="Close"
          >
            <X size={20} />
          </button>

          <div className="pr-8">
            <h3 className="text-md font-semibold text-green-800 mb-1">
              Help us improve Inspiriva Quotes
            </h3>
            <p className="text-gray-700 mb-2 text-sm leading-relaxed">
              We'd like to collect anonymous usage data to help us understand how you use our app and improve your experience. We do not collect any personal information.
            </p>

            <div className="flex gap-3">
              <Button
                onClick={handleAccept}
                className="bg-green-600 hover:bg-green-700 text-white"
              >
                Accept
              </Button>
              <Button
                onClick={handleReject}
                variant="outline"
                className="border-green-600 text-green-700 hover:bg-green-50"
              >
                Decline
              </Button>
            </div>

            <p className="text-xs text-gray-600 mt-2">
              You can change this preference anytime in our{' '}
              <a href={privacyPolicyUrl} target='_blank' className="text-green-600 hover:text-green-700 hover:underline">
                Privacy Policy
              </a>.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AnalyticsConsentBanner;